export const sharedEnvironmentUtv = {
  production: false,
  name: 'Development',
  bgcolor: 'red',
  fontcolor: 'white',
  showEnvironment: true,
  cookieDomain: '.vinnova.se',

  //Endpoints
  portalAdminUrl: 'https://e-admin.utv.vinnova.se/adminportal',
  nJobEngineUrl: 'https://e-admin.utv.vinnova.se/njobengine',
  notifyServiceApiUrl: 'https://notifiering.api.utv.vinnova.se',
  eadminUrl: 'https://e-admin.utv.vinnova.se',
  sprakHanteringApiUrl: 'https://sprakresurser.api.utv.vinnova.se/api',
  bedomarpoolAdminUrl: 'https://bedomarpooladmin.utv.vinnova.se',
  oregApiUrl: 'https://organisationsregistret.api.utv.vinnova.se/api',
  bpoolApiUrl: 'https://bedomarpooladmin.api.utv.vinnova.se',
  effektaUrl: 'https://effekta.utv.vinnova.se',
  formBuilderApiUrl: 'https://formularbyggare.api.utv.vinnova.se',
  formBuilderUrl: 'https://formularbyggare.utv.vinnova.se',
  formAdmin: 'https://formularadmin.api.utv.vinnova.se',
  etjansterCommonApiUrl: 'https://etjanster.api.utv.vinnova.se',
  etjansterCommonUrl: 'https://etjanster.utv.vinnova.se',
  bpUrl: 'https://bedomningsportal.utv.vinnova.se',
  bpApiUrl: 'https://bedomningsportal.api.utv.vinnova.se/api',
  enkatRegisterUrl: 'https://projekt.utv.vinnova.se/enkatregister',
  oregUrl: 'https://projekt.utv.vinnova.se/oreg',
  healthMonitorApiUrl: 'https://monitorering.api.utv.vinnova.se',
  ansokanApiUrl: 'https://ansok.api.utv.vinnova.se',
  ansokanUrl: 'https://ansok.utv.vinnova.se',
  forhandsgranskaApiUrl: 'https://forhandsgranska.api.utv.vinnova.se/api',
  forhandsgranskaUrl: 'https://forhandsgranska.utv.vinnova.se',
  utlysningsbyggareApiUrl: 'https://utlysningsbyggare.api.utv.vinnova.se/api',
  utlysningsbyggareUrl: 'https://utlysningsbyggare.utv.vinnova.se',
  projektUrl: 'https://projekt.utv.vinnova.se',
  logServiceApiUrl: 'https://loggservice.api.utv.vinnova.se',
  gatewayUrl: 'https://utv.api.vinnova.se',
  signeringApiUrl: 'https://signering.api.utv.vinnova.se/api',

  apimSubscriptionKey: 'abc95cfaab0f443e9b3ac6d3241426a7',

  // Keys
  tinyMceApiKey: '3v8orrp96m8v7vwbg61c31rrhu3dffg5wi6rlluihkl56ot0',

  //ClientIds
  azureAd: {
    formBuilderClientId: '056d9781-54a0-48de-b4b2-0ab7b4195366',
    formBuilderApiClientId: 'deb3816a-34f5-4971-8bcd-8fbe04ef7082',
    formAdminApiClientId: '8c8a3931-41f0-4600-a5f9-6f66e8f6e9e5',
    etjansterCommonApiClientId: '1ee0c953-8a37-4cca-a9e5-9341779a4a49',
    etjansterCommonApiScope: 'api://1ee0c953-8a37-4cca-a9e5-9341779a4a49/all',
  },
  azureAdB2C: {
    tenant: 'vinnovab2cutv',
    authority:
      'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/',
    policies: {
      signUp: {
        name: 'B2C_1A_signup',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1A_signup',
      },
      sso: {
        name: 'B2C_1_signupsignin_sso',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1_signupandsignin_sso',
      },
      signInPhone: {
        name: 'B2C_1A_signin_phone',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1A_signin_phone',
      },
      profileEdit: {
        name: 'B2C_1_profileedit',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1_profileedit',
      },
      passwordChange: {
        name: 'B2C_1A_profile_edit_password_change',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1a_profile_edit_password_change',
      },
      changeSignInName: {
        name: 'B2C_1A_changesigninname',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1a_changesigninname',
      },
      signIn: {
        name: 'B2C_1A_signin',
        authority:
          'https://vinnovab2cutv.b2clogin.com/vinnovab2cutv.onmicrosoft.com/b2c_1A_signin',
      },
    },
    clientId: {
      etjansterCommonClientId: 'a2ca34e6-9357-4eb7-b13d-35e6a234d167',
      etjansterCommonApiClientId: 'c749d848-b572-419d-95f2-40e2df185c79',
      ansokanClientId: '2fd9584d-ca18-493e-9501-658e1a4ec6ed',
      ansokanApiClientId: 'c7ca4cb3-665e-493e-9227-8a4d8dacc7ca',
      bedomningsportalClientId: '07a05ae5-fae5-41b7-9cde-3b7d29f3b9b8',
      bedomningsportalApiClientId: 'ea4f6247-3ecc-465b-aecb-ee212e0b96a6',
      projektClientId: '8393e179-eb2d-47e9-9696-6d33f2f6df65',
      projektApiClientId: 'ceff5095-4ef3-4c70-94b8-1c367923c615',
      forhandsgranskaClientId: 'e666c5a2-7d1d-4118-8964-015c13fcf0fb',
      forhandsgranskaApiClientId: '12d40822-7b63-4e74-a6ab-1b3c4c05ce9f',
      utlysningsbyggareClientId: 'xxx',
      utlysningsbyggareApiClientId: 'xxx',
      enkatregisterApiClientId: 'be734112-3eca-40f1-87ee-1d50eb9b8f95',
      oregApiClientId: '9d78bc17-4a35-4d14-8685-8793e09661af',
      signeraApiClientId: '9bf435cf-8260-4b11-8650-784e392dd840',
    },
  },
  //Externa länkar
  externalLinks: {
    ansokanGuide: {
      sv: 'https://www.vinnova.se/sok-finansiering/sa-har-fyller-du-i-ansokan/',
      en: 'https://www.vinnova.se/en/apply-for-funding/how-to-complete-your-application/',
    },
    regler: {
      sv: 'https://www.vinnova.se/sok-finansiering/regler-for-finansiering/',
      en: 'https://www.vinnova.se/en/apply-for-funding/rules-for-our-funding/',
    },
    gdpr: {
      sv: 'https://www.vinnova.se/om-oss/vart-uppdrag/regler-som-styr-var-verksamhet/personuppgifter/',
      en: 'https://www.vinnova.se/en/about-us/our-mission/rules-that-govern-our-activities/how-we-handle-personal-data/',
    },
  },
  ga4MeasurementId: 'G-DJPY2PMYE7',
};
